import { NgForOf } from '@angular/common';
import {
    ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output,
} from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { GridLastSizesComponent } from '../grid-last-sizes/grid-last-sizes.component';

import { Category } from '@core/domain/models/category.models';
import { MediasPublicConstants } from '@features/products/medias';
import { AddToCartSheetModel, ProductViewComponent } from '@shared/product';
import { AddToCartBottomSheetComponent } from '@shared/product/components/add-to-cart-bottom-sheet/add-to-cart-bottom-sheet.component';
import { CategoryConfiguration, ProductViewConfig, ProductViewPlace } from '@shared/product/models';

@Component({
    selector: 'app-grid-default-2',
    templateUrl: './grid-default-2.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgForOf,
        ProductViewComponent,
        AddToCartBottomSheetComponent,
        InfiniteScrollModule,
        GridLastSizesComponent,
    ],
})
export class GridDefault2Component implements OnInit {
    @Input() public defaultImageTypes: Map<number, string>;

    @Input() public category: Category;

    @Input() public isCategoryNew: boolean;

    @Input() public productIds: number[];

    @Input() public place: ProductViewPlace;

    @Input() public seoCategoryName: string;

    @Input() public showMediaCarousel: boolean;

    @Input() public showLastSizesGrid: boolean;

    @Output() public readonly loadNextPageEvent: EventEmitter<void> = new EventEmitter();

    public templateConfiguration: ProductViewConfig;

    public loadLayerAddCart: boolean;

    public categoryConfiguration: CategoryConfiguration; // Product View deberia recibir solo la TemplateConfiguration

    public addToCartSheetModel: AddToCartSheetModel;

    public ngOnInit(): void {
        this.categoryConfiguration = {
            soldOut: false,
            productConf: new Map(),
            category: this.category,
            isCategoryNew: this.isCategoryNew,
        };
        this.templateConfiguration = {
            media: {
                ratio: '3-4',
            },
            location: MediasPublicConstants.PublicMediaLocationType.ZOOM_2,
            place: this.place,
            clickable: true,
            discardDoubleVideo: true,
            discardFallback: true,
            showQuickly: true,
            showQuicklyMobile: true,
            showMediaCarousel: this.showMediaCarousel,
            // eslint-disable-next-line no-secrets/no-secrets
            set: 0, // https://jira.inditex.com/jira/browse/ITSMECOM-3554928 (hardcoded 0)
        };
    }

    public onScroll(): void {
        this.loadNextPageEvent.emit();
    }

    public addToCartSheet({ product }) {
        this.addToCartSheetModel = {
            product,
            categoryId: this.category?.id,
            fullView: true,
        };
    }

    public closeAddToCartSheet() {
        this.addToCartSheetModel = null;
    }
}
